import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SecurityService } from "src/app/authentication/service/security.service";

import { MatSnackBar } from "@angular/material/snack-bar";
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  constructor(
    private router: Router,
    private securityService: SecurityService,
    private _snackBar: MatSnackBar,
  ) {
    securityService.signOut();
  }

  ngOnInit(): void {}
  requestGoogleLogin(): void {
    this.securityService.login();
  }

  showSnackBar(message: any, action: any) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }
}
